import styled from "@emotion/styled"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"
import { getNonUmbracoUrl, Link } from "utils"
import ArrowDown from "../../icons/ArrowDown"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.up("md")} {
    display: none;
  }
`

const StyledAccordion = styled(Accordion)<{ index: number }>`
  padding: 0 !important;
  box-shadow: none !important;
  background-color: transparent;
  ::before {
    display: none;
  }
  & path {
    stroke: white;
  }
  &.Mui-expanded {
    margin: 0 !important;
  }
  & .MuiAccordionSummary-root {
    min-height: 0 !important;
    height: 56px;
    border-bottom: 1px solid #f5f6f8 !important;
  }
  & .MuiAccordionSummary-content {
    margin: 0 !important;
  }
  & .MuiAccordionDetails-root {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 16px;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
  &:hover {
    box-shadow: inset 0 -1px 0 0 white;
  }
`

export default function MobileLinks({
  megaMenuItems,
}: {
  megaMenuItems: { name: string; links: { name: string; url: string }[] }[]
}) {
  return (
    <StyledLayout>
      {megaMenuItems.map((item, i) => (
        <StyledAccordion key={i} index={i}>
          <AccordionSummary
            expandIcon={<ArrowDown />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1" color="white">
              {item.name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {item.links.map((el, x) => (
              <StyledLink
                href={getNonUmbracoUrl(el.url)}
                key={x}
                prefetch={false}
              >
                <Typography variant="body2" color="white">
                  {el.name}
                </Typography>
              </StyledLink>
            ))}
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </StyledLayout>
  )
}
